import {
  FeatureRequestButton,
  FeatureRequestButtonProps,
} from './FeatureRequestButton'
import { EnquiryFeature, CohortPriceContext } from '@/types/enquiry'
import { useEnquiriesExperience } from '@/app/providers/Enquiries'
import { useTranslations } from 'next-intl'

type CohortPriceEnquiryButtonProps = Omit<
  FeatureRequestButtonProps,
  'featureRequest' | 'context'
> & {
  cohortId?: string
}

export function CohortPriceEnquiryButton({
  cohortId,
  ...props
}: CohortPriceEnquiryButtonProps) {
  const t = useTranslations('Enquiries')
  const { baseContext } = useEnquiriesExperience()
  const context: CohortPriceContext = {
    cohort: cohortId ?? baseContext.cohort!,
    course: baseContext.course!,
    educationProvider: baseContext.educationProvider!,
  }

  return (
    <FeatureRequestButton
      {...props}
      featureRequest={EnquiryFeature.CohortPrice}
      context={context}
    >
      {t('request-cohort-price')}
    </FeatureRequestButton>
  )
}
